/** Builds the standalone DOM element used as the third PDF page.
 *  position:fixed at top:0 ensures Chrome fully lays out the element
 *  (off-screen elements are skipped by the renderer and capture as 0-height).
 *  z-index:99 keeps it below the pdfGenerating spinner at z-[100], so the
 *  user never sees it during generation. */
export function buildOriginalValuesElement(
  exceptions: Record<string, { label: string; previousVal: any; newVal: any }>,
  notes: Record<string, string> = {}
): HTMLElement {
  const el = document.createElement("div");
  el.id = "pdf-original-values";
  el.style.cssText =
    "position:fixed;top:0;left:0;z-index:99;width:1100px;background:#0C1017;color:#e2e8f0;" +
    "padding:10px 0px;font-family:ui-sans-serif,system-ui,sans-serif;box-sizing:border-box;";

  const GOLD    = "#FD9F29";
  const BORDER  = "1px solid hsl(216,11%,22%)";
  const CARD_BG = "background:hsl(216,11%,15%);";
  const CELL    = `padding:6px 16px;border-right:${BORDER};border-bottom:${BORDER};vertical-align:middle;${CARD_BG}`;
  const TH      = `text-align:left;padding:12px 16px;color:${GOLD};font-size:11px;text-transform:uppercase;` +
                  `letter-spacing:0.05em;font-weight:600;white-space:nowrap;border-right:${BORDER};border-bottom:${BORDER};` +
                  `background:rgba(255,255,255,0.04);`;

  const TABLE_STYLE = `width:100%;border-collapse:collapse;border:${BORDER};`;
  const THEAD = `
    <thead>
      <tr>
        <th style="${TH}width:22%;">Field Name</th>
        <th style="${TH}width:13%;">Original Value</th>
        <th style="${TH}width:13%;">Updated Value</th>
        <th style="${TH}width:52%;text-align:center;border-right:none;">Reason for Change</th>
      </tr>
    </thead>`;
  const TABLE_OPEN  = `<div style="padding:0 24px 24px 24px;"><table style="${TABLE_STYLE}">${THEAD}<tbody>`;
  const TABLE_CLOSE = `</tbody></table></div>`;

  const entries = Object.entries(exceptions);
  let rowsHtml = TABLE_OPEN;

  entries.forEach(([fieldKey, info]) => {
    const label      = (info as any)?.label      ?? fieldKey;
    const previousVal = (info as any)?.previousVal ?? "—";
    const newVal      = (info as any)?.newVal      ?? "—";
    const note        = notes[fieldKey]             ?? "";
    rowsHtml += `
      <tr>
        <td style="${CELL}font-size:14px;color:#e2e8f0;width:25%;">${label}</td>
        <td style="${CELL}font-size:14px;color:#f87171;width:13%;">${previousVal}</td>
        <td style="${CELL}font-size:14px;color:#4ade80;width:13%;">${newVal}</td>
        <td style="${CELL}font-size:12px;color:#94a3b8;font-style:italic;width:49%;border-right:none;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;max-width:0;">${note}</td>
      </tr>`;
  });

  rowsHtml += TABLE_CLOSE;

  el.innerHTML = `
    <div style="background:hsl(216,11%,15%);">
      <div style="padding:24px 24px 16px 24px;">
        <h2 style="font-size:22px;font-weight:600;color:${GOLD};margin:0;">Loan Application Data Changes</h2>
      </div>
      ${rowsHtml}
    </div>`;
  return el;
}
